module.exports = __webpack_public_path__ + "static/media/boys-t-shirt.8eb21733.jpg";